import { css } from '@/styled-system/css';

export const styledErrorParagraphStyles = css({
  color: 'text.critical',
  marginLeft: '400',
});
